import { render } from "./echartsSimple.vue?vue&type=template&id=710c8110"
import script from "./echartsSimple.vue?vue&type=script&lang=js"
export * from "./echartsSimple.vue?vue&type=script&lang=js"

import "./echartsSimple.vue?vue&type=style&index=0&id=710c8110&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_716deba8f9fb0f99912277de341ea52b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__